import { useTranslation } from 'react-i18next';

import { Box } from '@valwin/facto/components';

import { useCountdown } from '~shared/lib';

type CountdownTextProps = {
  seconds: number;
  onComplete?: () => void;
};

export function CountdownText({ seconds, onComplete }: CountdownTextProps) {
  const { t } = useTranslation();
  const count = useCountdown(seconds, onComplete);

  return <Box>{t('common closingIn', { count })}</Box>;
}
